import { initInternationalPhoneInputs } from '../../helpers/international-phone-inputs';
import { initConsentManagement } from '../../helpers/consent-management.js';
import { initModals } from '../../components/modals';
import { initTracking } from '../../tracking';
import { initCaptchas } from '../../helpers/captchas';
import { initPreload } from '../../helpers/preload';
import { generalCallbacks } from '../../form-callbacks/general';
import { consentCallbacks } from '../../form-callbacks/consent';
import { shiftSubdomain } from '../../helpers/extract-domain';
const initializers = [
    initModals,
    initInternationalPhoneInputs,
    initTracking,
    initConsentManagement,
    initCaptchas,
    initPreload,
];
const initialize = () => {
    initializers.forEach((initializer) => {
        try {
            initializer();
        }
        catch (e) {
            console.log(e);
        }
    });
};
initialize();
Object.assign(window, generalCallbacks, consentCallbacks);
window.shiftSubdomain = shiftSubdomain;
window.addLibsLoadedScript = (fn) => fn();
if (typeof window.libsLoadedScripts === 'object') {
    window.libsLoadedScripts.forEach((fn) => {
        try {
            fn();
        }
        catch (e) {
            console.error(e);
        }
    });
}
